import { fleetRecordPath } from '../../fleet.paths';

/** A trailer's own page gives each tab its own route, `/fleet/trailers/:id/<tab>` (`recordTabRoutes`). */
export const TRAILER_TABS = ['details', 'documents', 'ownership', 'history'] as const;
export type TrailerTab = (typeof TRAILER_TABS)[number];

export const TRAILER_TAB_LABELS: Record<TrailerTab, string> = { details: 'Details', documents: 'Documents', ownership: 'Ownership', history: 'History' };

export function trailerTabPath(id: string, tab: TrailerTab): string {
  return `${fleetRecordPath('trailers', id)}/${tab}`;
}
